import { CdkCellDef } from "@angular/cdk/table";
import { Directive, Input } from "@angular/core";
import { MatCellDef, MatTableDataSource } from "@angular/material/table";
import { Observable } from "rxjs";

// https://nartc.me/blog/typed-mat-cell-def/
@Directive({
    selector: "[matCellDef]", // same selector as MatCellDef
    providers: [{ provide: CdkCellDef, useExisting: TypeSafeMatCellDefDirective }],
    standalone: true,
})
export class TypeSafeMatCellDefDirective<T> extends MatCellDef {
    // leveraging syntactic-sugar syntax when we use *matCellDef
    @Input({ required: true }) matCellDefDataSource!: T[] | Observable<T[]> | MatTableDataSource<T>;

    // ngTemplateContextGuard flag to help with the Language Service
    static ngTemplateContextGuard<T>(
        dir: TypeSafeMatCellDefDirective<T>,
        ctx: unknown,
    ): ctx is { $implicit: T; index: number } {
        return true;
    }
}
